import { action, observable } from 'mobx'
import Api from '@api/localMerchant/NameCard'

export default class {
  constructor(props) {
    this.parent_store = props
  }

  @observable detail = {}

  getAltasList = async id => {
    const { success, data } = await Api.photoSetDetail({ id })
    if (success) {
      this.detail = data
    }
  }

  @action handleImgList = () => {}
}
